import * as React from 'react';
import { FlourishEmbed } from '../../embed';
export var FlourishChart = function (props) {
    var description = props.description, link = props.link;
    var flourishId = link.replace('https://public.flourish.studio/visualisation/', '').replace('/', '');
    var src = "https://flo.uri.sh/visualisation/".concat(flourishId, "/embed");
    return (React.createElement(FlourishEmbed, { src: src, description: description }));
};
